import React from 'react';
import BuilderElementMask, {
    BuilderElementMaskProps,
} from '@form-engine/builder-mask/components/mask';
import BuilderMaskGroup from '@form-engine/builder-mask/components/mask/group';
import BuilderBooleanProperty from '@form-engine/builder-mask/components/properties/boolean';
import BuilderMaskGroupAppearance from '@form-engine/builder-mask/components/groups/appearance';
import BuilderFloatingLabelProperty from '@form-engine/builder-mask/components/properties/floating-label';
import BuilderLabelProperty from '@form-engine/builder-mask/components/properties/label';

import BuilderDataSourceProperty from '@form-engine/builder-mask/components/properties/data-source';
import BuilderMaskGroupValidation from '@form-engine/builder-mask/components/groups/validation';
import BuilderMaskGroupConditions from '@form-engine/builder-mask/components/groups/conditions';
import BuilderExpressionsProperty from '@form-engine/builder-mask/components/properties/expressions';
import { CONTROL_TYPES, ControlTypes } from '../select-element';
import { Element } from '.';
import { useMaskContext } from '@form-engine/builder-mask/hooks/use-mask';
import BuilderStringProperty from '@form-engine/builder-mask/components/properties/string';
import { i18n } from '@form-engine/builder-application';
import BuilderEnumProperty from '@form-engine/builder-mask/components/properties/enum';
import { StoreData } from '@form-engine/core-application/hooks/use-store';

export default function BuilderSelectElementMask(
    props: BuilderElementMaskProps
) {
    const { state } = useMaskContext<
        StoreData & { controlType?: ControlTypes }
    >();

    const { controlType = CONTROL_TYPES.NATIVE } = state ?? {};

    const { c } = i18n.prefix(`mask.${Element.apiName}.`);

    return (
        <BuilderElementMask id={Element.apiName} {...props}>
            <BuilderMaskGroupAppearance />
            <BuilderMaskGroup label={c('groupTitle')}>
                <BuilderLabelProperty />

                <BuilderEnumProperty
                    propertyName="controlType"
                    label={c('controlType')}
                    defaultValue={CONTROL_TYPES.NATIVE}
                    options={[
                        [CONTROL_TYPES.NATIVE, c('controlTypes.native')],
                        [CONTROL_TYPES.ADVANCED, c('controlTypes.advanced')],
                    ]}
                />
                {controlType === CONTROL_TYPES.ADVANCED && (
                    <>
                        <BuilderBooleanProperty
                            propertyName="searchable"
                            label={c('searchable')}
                            defaultValue={true}
                        />
                        <BuilderStringProperty
                            propertyName="placeholder"
                            label={c('placeholder')}
                            placeholder="Select..."
                        />
                    </>
                )}
                <BuilderFloatingLabelProperty />
                <BuilderBooleanProperty
                    propertyName="showError"
                    label={c('showError')}
                />
                {controlType === CONTROL_TYPES.NATIVE && (
                    <>
                        <BuilderBooleanProperty
                            propertyName="showDefaultOption"
                            label={c('showDefaultOption')}
                        />
                        {Boolean(state?.showDefaultOption) && (
                            <BuilderStringProperty
                                propertyName="defaultOptionLabel"
                                label={c('defaultOptionLabel')}
                                placeholder={c('defaultOptionLabelPlaceholder')}
                            />
                        )}
                    </>
                )}

                <BuilderDataSourceProperty label={c('datasource')} />
                <BuilderExpressionsProperty
                    label={c('datasourceExpressions')}
                    propertyName="datasourceExpressions"
                    variableOptions={['$i.']}
                />
            </BuilderMaskGroup>
            <BuilderMaskGroupValidation />
            <BuilderMaskGroupConditions />
        </BuilderElementMask>
    );
}
